import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'driver'],

    data() {
        return {
            title: 'Dodaj vozača',
            passwordTitle: 'Lozinka',
            buttonTitle: 'Dodaj',
            isLoading: false,
            selectedDriver: null,
            username: '',
            password: '',
            name: '',
            lastName: '',
            phoneNumber: '',
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedDriver = this.driver;
                if(this.selectedDriver != null){
                    this.username = this.selectedDriver.name;
                    this.name = this.checkNull(this.selectedDriver.firstName);
                    this.lastName = this.checkNull(this.selectedDriver.lastName);
                    this.phoneNumber = this.checkNull(this.selectedDriver.phoneNumber);
                    this.password = '';
                    this.title = 'Izmeni vozača: ' + this.selectedDriver.name;
                    this.passwordTitle = 'Nova lozinka (ostaviti prazno ukoliko ne želite da promenite)';
                    this.buttonTitle = 'Izmeni';
                }else{
                    this.title = 'Dodaj vozača ';
                    this.lastName = '';
                    this.passwordTitle = 'Lozinka';
                    this.buttonTitle = 'Dodaj';
                    this.reset();
                }
            }
        },
        name: function(val, oldVal) {
            this.hasError = '';
        },
        phoneNumber: function(val, oldVal) {
            this.hasError = '';
        },
        username: function(val, oldVal) {
            this.hasError = '';
        },
        password: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddUser')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddUser')
        },
        addUser: addUser,
        editUser: editUser,
        checkNull: checkNull,
        reset: reset,
    }
}

function editUser() {
    if(this.username.length === 0 ||
        this.name.length === 0 ||
        this.lastName.length === 0 ||
        this.phoneNumber.length === 0) {
        this.hasError = "Molimo popunite sva ime, nadimak, telefon i korisničko ime. Ukoliko popunite i lozinku biće promenjena.";
        return;
    }
    let _self = this;
    const newModel = {
        firstName: _self.name,
        lastName: _self.lastName,
        phoneNumber: _self.phoneNumber,
        username: _self.username,
        password: _self.password === '' || _self.password == null ? null : _self.password
    };
    _self.isLoading = true;
    AdminApiService.updateDriver(newModel, _self.selectedDriver.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        }).catch((error) => {
        _self.isLoading = false;
        try{
            _self.hasError = "Greška: "+ error.data.message;
        }catch (e) {
            _self.hasError = "Greška prilikom izmene."
        }
    })
}

function addUser() {
    if(this.selectedDriver != null){
        this.editUser();
        return;
    }
    if(this.username.length === 0 ||
        this.name.length === 0 ||
        this.lastName.length === 0 ||
        this.phoneNumber.length === 0 ||
        this.password.length === 0 ) {
        this.hasError = "Molimo popunite sva polja";
        return;
    }
    let _self = this;
    const newModel = {
        firstName: _self.name,
        lastName: _self.lastName,
        phoneNumber: _self.phoneNumber,
        username: _self.username,
        password: _self.password
    };
    _self.isLoading = true;
    AdminApiService.createUser(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        }).catch((error) => {
            _self.isLoading = false;
            try{
                _self.hasError = "Greška: "+ error.data.message;
            }catch (e) {
                _self.hasError = "Greška prilikom dodavanja."
            }
        })

}

function reset() {
    this.username = '';
    this.password = '';
    this.phoneNumber = '';
    this.name = '';
    this.lastName = '';
    this.selectedDriver = null;
}


function checkNull(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/modals/AddUserModal.js